<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-search text-primary pr-2"></i>
                    Búsqueda Avanzada de Socios
                </h4>
            </b-col>
        </b-row>

        <b-row md="12" class="pb-3">

            <b-col class="col-md-12 p-0">

                <b-card class="bg-white w-100 px-2 mb-0">

                    <h4 class="w-100 text-left text-primary">Información General</h4>

                    <b-row md="12" class="bg-light px-2 pt-2 pb-3">

                        <b-col class="col-md-4">

                            <!-- ////////////////////// Estado ////////////////////// !-->
                            <b-form-group
                                label="<strong>Estado</strong>"
                                :horizontal="false"
                                label-for="status"
                                class="w-100 mb-0">

                                <multiselect
                                    id="status"
                                    v-model="entity.active"
                                    :options="memberStatusOptions"
                                    track-by="key"
                                    label="value"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-">

                                </multiselect>

                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Situación ////////////////////// !-->
                            <b-form-group
                                label="<strong>Situación</strong>"
                                label-for="situation"
                                :horizontal="false"
                                class="w-100 mb-0">

                                <multiselect
                                    id="situation"
                                    v-model="entity.located"
                                    :options="memberLocatedOptions"
                                    track-by="key"
                                    label="value"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-">
                                </multiselect>

                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">

                            <!-- ////////////////////// Código ////////////////////// !-->
                            <b-form-group
                                label="<strong>Código</strong>"
                                label-for="code"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="code"
                                    name="code"
                                    type="text"
                                    placeholder="Código"
                                    v-model="entity.code"
                                    class="w-100"
                                    :state="validateState('code')"
                                    aria-describedby="check_code"></b-form-input>
                                <div class="text-danger text-right" id="check_code">
                                    <small>{{ errors.first('code') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// NIF ////////////////////// !-->
                            <b-form-group
                                label="<strong>NIF</strong>"
                                label-for="nif"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="nif"
                                    name="nif"
                                    type="text"
                                    placeholder="NIF"
                                    v-model="entity.nif"
                                    class="w-100"
                                    v-validate="'min:3'"
                                    :state="validateState('nif')"
                                    aria-describedby="check_nif"></b-form-input>
                                <div class="text-danger text-right" id="check_nif">
                                    <small>{{ errors.first('nif') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Sede ////////////////////// !-->
                            <b-form-group
                                label="<strong>Sede</strong>"
                                label-for="headquarters"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <headquarters-multiple-selector
                                    id="headquarters"
                                    v-model="entity.headquarters"
                                    :allowEmpty="true"></headquarters-multiple-selector>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Nombre ////////////////////// !-->
                            <b-form-group
                                label="<strong>Nombre</strong>"
                                label-for="name"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Nombre"
                                    v-model="entity.name"
                                    class="w-100"
                                    :state="validateState('name')"
                                    aria-describedby="check_name"></b-form-input>
                                <div class="text-danger text-right" id="check_name">
                                    <small>{{ errors.first('name') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Apellidos ////////////////////// !-->
                            <b-form-group
                                label="<strong>Apellidos</strong>"
                                label-for="surname"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="surname"
                                    name="surname"
                                    type="text"
                                    placeholder="Apellidos"
                                    v-model="entity.surname"
                                    class="w-100"
                                    :state="validateState('surname')"
                                    aria-describedby="check_surname"></b-form-input>
                                <div class="text-danger text-right" id="check_surname">
                                    <small>{{ errors.first('surname') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Comercial ////////////////////// !-->
                            <b-form-group
                                label="<strong>Comercial</strong>"
                                label-for="businessManager"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <multiselect
                                    name="businessManager"
                                    v-model="entity.businessManagerId"
                                    :options="filterUsers(users)"
                                    :multiple="false"
                                    :allowEmpty="true"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    autocomplete="nope">
                                    <template slot="singleLabel" slot-scope="props">
                                        {{ getUserLabel(props.option.uuid) }}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <small>{{ getUserLabel(props.option.uuid) }}</small>
                                        <pre>{{ getUserDepartmentLabel(props.option.uuid) }}</pre>
                                    </template>
                                </multiselect>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Email ////////////////////// !-->
                            <b-form-group
                                label="<strong>Email</strong>"
                                label-for="email"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    v-model="entity.email"
                                    class="w-100"
                                    v-validate="'email'"
                                    :state="validateState('email')"
                                    aria-describedby="check_email"></b-form-input>
                                <div class="text-danger text-right" id="check_email">
                                    <small>{{ errors.first('email') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Teléfono / Fax ////////////////////// !-->
                            <b-form-group
                                label="<strong>Teléfono / Fax</strong>"
                                label-for="phone"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="phone"
                                    name="phone"
                                    type="number"
                                    placeholder="Teléfono / Fax"
                                    v-model="entity.phone"
                                    class="w-100"
                                    v-validate="'phone'"
                                    :state="validateState('phone')"
                                    aria-describedby="check_phone"></b-form-input>
                                <div class="text-danger text-right" id="check_phone">
                                    <small>{{ errors.first('phone') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->

                        </b-col>

                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">
                            <!-- ////////////////////// CIF Empresa ////////////////////// !-->
                            <b-form-group
                                label="<strong>CIF Empresa</strong>"
                                label-for="companyCif"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="companyCif"
                                    name="companyCif"
                                    type="text"
                                    placeholder="CIF Empresa"
                                    v-model="entity.companyCif"
                                    class="w-100"
                                    v-validate="'min:3'"
                                    :state="validateState('companyCif')"
                                    aria-describedby="check_companyCif"></b-form-input>
                                <div class="text-danger text-right" id="check_companyCif">
                                    <small>{{ errors.first('companyCif') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Nombre Empresa ////////////////////// !-->
                            <b-form-group
                                label="<strong>Nombre Empresa</strong>"
                                label-for="companyName"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="companyName"
                                    name="companyName"
                                    type="text"
                                    placeholder="Nombre Empresa"
                                    v-model="entity.companyName"
                                    class="w-100"
                                    v-validate="'min:3'"
                                    :state="validateState('companyName')"
                                    aria-describedby="check_companyName"></b-form-input>
                                <div class="text-danger text-right" id="check_companyName">
                                    <small>{{ errors.first('companyName') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Provincia ////////////////////// !-->
                            <b-form-group
                                label="<strong>Provincia</strong>"
                                label-for="province"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="province"
                                    name="province"
                                    type="text"
                                    placeholder="Provincia"
                                    v-model="entity.province"
                                    class="w-100"
                                    :state="validateState('province')"
                                    aria-describedby="check_province"></b-form-input>
                                <div class="text-danger text-right" id="check_province">
                                    <small>{{ errors.first('province') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>
                        <b-col class="col-md-4">
                            <!-- ////////////////////// Ciudad ////////////////////// !-->
                            <b-form-group
                                label="<strong>Ciudad</strong>"
                                label-for="town"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="town"
                                    name="town"
                                    type="text"
                                    placeholder="Ciudad"
                                    v-model="entity.town"
                                    class="w-100"
                                    :state="validateState('town')"
                                    aria-describedby="check_town"></b-form-input>
                                <div class="text-danger text-right" id="check_town">
                                    <small>{{ errors.first('town') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>
                        <b-col class="col-md-4">
                            <!-- ////////////////////// Código Postal ////////////////////// !-->
                            <b-form-group
                                label="<strong>Código Postal</strong>"
                                label-for="postalCode"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="postalCode"
                                    name="postalCode"
                                    type="number"
                                    placeholder="Código Postal"
                                    v-model="entity.postalCode"
                                    class="w-100"
                                    :state="validateState('postalCode')"
                                    aria-describedby="check_postalCode"></b-form-input>
                                <div class="text-danger text-right" id="check_postalCode">
                                    <small>{{ errors.first('postalCode') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->

                        </b-col>
                    </b-row>

                    <b-row md="12" class="bg-light px-2 pb-3">

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Cuenta Bancaria ////////////////////// !-->
                            <b-form-group
                                label="<strong>IBAN</strong>"
                                label-for="iban"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="iban"
                                    name="iban"
                                    type="number"
                                    placeholder="IBAN"
                                    v-model="entity.iban"
                                    class="w-100"
                                    :state="validateState('iban')"
                                    aria-describedby="check_iban"></b-form-input>
                                <div class="text-danger text-right" id="check_iban">
                                    <small>{{ errors.first('iban') }}</small>
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Convenio ////////////////////// !-->
                            <b-form-group
                                label="<strong>Convenio</strong>"
                                label-for="agreement"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <fee-agreement-selector
                                    id="agreement"
                                    v-model="entity.agreement"
                                    :allowEmpty="true"></fee-agreement-selector>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                        <b-col class="col-md-4">
                            <!-- ////////////////////// Tipo de Cuota ////////////////////// !-->
                            <b-form-group
                                label="<strong>Tipo de Cuota</strong>"
                                label-for="feeType"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <fee-type-multiple-selector :allowEmpty="true" v-model="entity.feeTypes"></fee-type-multiple-selector>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <h4 class="w-100 text-left text-primary mt-4">Filtro Adicional</h4>

                    <b-row md="12" class="bg-light px-2 py-2">
                        <b-col md="6">
                            <b-form-group
                                label="<strong>Buscar entre fechas:</strong>"
                                label-for="registerDate">

                                <b-row md="12" class="bg-light p-0">
                                    <b-col>
                                        <v-date-picker
                                            id="registerDate"
                                            v-model="registerDateBegin"
                                            :input-props='{ placeholder: "Fecha inicio" }'
                                            :max-date="new Date()"
                                            class="date-picker-w-100 date-picker-custom-border">
                                        </v-date-picker>
                                    </b-col>
                                    <b-col>
                                        <v-date-picker
                                            id="registerDate2"
                                            v-model="registerDateEnd"
                                            :input-props='{ placeholder: "Fecha fin" }'
                                            :max-date="new Date()"
                                            class="date-picker-w-100 date-picker-custom-border">
                                        </v-date-picker>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group
                              label="<strong>Fecha de Baja:</strong>"
                              label-for="deActiveDate">

                              <b-row md="12" class="bg-light p-0">
                                <b-col>
                                  <v-date-picker
                                    id="deActiveDate"
                                    v-model="deActiveDateBegin"
                                    :input-props='{ placeholder: "Fecha inicio" }'
                                    :max-date="new Date()"
                                    class="date-picker-w-100 date-picker-custom-border">
                                  </v-date-picker>
                                </b-col>
                                <b-col>
                                  <v-date-picker
                                    id="deActiveDate2"
                                    v-model="deActiveDateEnd"
                                    :input-props='{ placeholder: "Fecha fin" }'
                                    :max-date="new Date()"
                                    class="date-picker-w-100 date-picker-custom-border">
                                  </v-date-picker>
                                </b-col>
                              </b-row>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Edad</strong>"
                                label-for="age"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="age"
                                    name="age"
                                    type="number"
                                    placeholder="Edad"
                                    v-model="entity.age"
                                    class="w-100"
                                    aria-describedby="check_age"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label="<strong>CNAE</strong>"
                                label-for="amount"
                                :horizontal="false"
                                class="w-100 mb-0 mt-2">
                                <cnae-selector v-model="cnae" :allowEmpty="true"></cnae-selector>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group
                                label="<strong>Sexo</strong>"
                                label-cols="4"
                                label-for="sex">
                                <multiselect
                                    :allowEmpty="false"
                                    :custom-label="opt => sex.find(x => x.uuid == opt).name"
                                    :multiple="false"
                                    :options="sex.map(type => type.uuid)"
                                    deselectLabel="-"
                                    name="sex"
                                    placeholder="Seleccione"
                                    selectLabel="+"
                                    v-if="sex"
                                    v-model="entity.sex">
                                </multiselect>
                            </b-form-group>
                            <b-form-group
                                label="<strong>Forma de Pago</strong>"
                                label-for="paymentMethod"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <payment-method-multiple-selector :allowEmpty="true" id="paymentMethod" v-model="entity.paymentMethods"></payment-method-multiple-selector>
                            </b-form-group>
                            <b-form-group
                                label="&nbsp"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-checkbox class="mt-1" v-model="entity.isExemption">
                                    Exento de pago
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row md="12" class="bg-light px-2 py-2">
                        <b-col md="6">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox class="mt-1" v-model="showUnpaidAmount">
                                        Debe más de XX euros
                                    </b-form-checkbox>

                                    <b-form-input
                                        v-if="showUnpaidAmount"
                                        type="number"
                                        placeholder="Cantidad"
                                        v-model="entity.unpaidAmount"
                                        class="my-1"></b-form-input>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b-form-checkbox class="mt-1" v-model="showUnpaidReceipts">
                                        Debe más de XX recibos
                                    </b-form-checkbox>

                                    <b-form-input
                                        v-if="showUnpaidReceipts"
                                        type="number"
                                        placeholder="Recibos"
                                        v-model="entity.unpaidReceipts"
                                        class="my-1"></b-form-input>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="<strong>Fecha de Emisión de Recibo</strong>"
                                        label-for="receiptIssueDates"
                                        :horizontal="false"
                                        class="my-1">
                                        <receipt-issue-date-multiple-selector
                                            id="receiptIssueDates"
                                            v-model="entity.receiptIssueDates"
                                            :allowEmpty="true"></receipt-issue-date-multiple-selector>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <b-form-checkbox class="mt-1" v-model="showQueriesMinimum">
                                        Ha realizado al menos X consultas
                                    </b-form-checkbox>

                                    <b-form-input
                                        v-if="showQueriesMinimum"
                                        type="number"
                                        placeholder="Consultas"
                                        v-model="entity.queriesMinimum"
                                        class="my-1"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col md="6">


                            <b-row>
                                <b-col>
                                    <b-form-checkbox
                                        class="mt-1"
                                        id="includeUnlinkedMembers"
                                        v-model="entity.includeUnlinkedMembers">Incluir Vinculados
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>


                            <b-row>
                                <b-col>
                                    <b-form-checkbox
                                        class="mt-1"
                                        id="unsubscribeReason"
                                        v-model="unsubscribeReason">Incluir Socios de baja
                                    </b-form-checkbox>

                                    <multiselect
                                        v-if="unsubscribeReason"
                                        name="unsubscribeReasonId"
                                        class="my-1"
                                        v-model="entity.unsubscribeReasonId"
                                        :options="unsubscribeReasons.map(type => type.uuid)"
                                        :custom-label="opt => unsubscribeReasons.find(x => x.uuid == opt).name"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        deselectLabel="-">
                                    </multiselect>
                                </b-col>
                            </b-row>


                            <b-row>
                                <b-col>
                                    <b-form-checkbox
                                        class="mt-1"
                                        id="shareDataToThirdParties"
                                        v-model="entity.shareDataToThirdParties"
                                        :value="false"
                                        :unchecked-value="true">No consiente cesión de datos (LOPD)
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>

                        </b-col>
                    </b-row>

                    <b-row md="12" class="pt-3">
                        <b-col class="w-100 px-0 text-right">
                            <button
                                type="button"
                                class="btn btn-primary btn-brand float-center"
                                @click="search">
                                <i class="fa fa-search"></i><span>Buscar Socios</span></button>
                        </b-col>
                    </b-row>

                </b-card>

                <b-row md="12" class="pb-3 mx-1" v-if="show">

                    <b-col class="col-md-12 p-0">

                        <h4 class="col-md-12 text-center mt-4 text-primary">
                            <i class="fa fa-exchange text-primary mr-2"></i>
                            Resultados
                        </h4>

                        <b-card class="w-100">
                            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                                Listado de Socios
                                <div>
                                    <button
                                        :disabled="count<1"
                                        class="btn btn-primary btn-sm mr-2"
                                        @click="exportMembers('')">
                                        <i class="fa fa-download"></i> Exportar todo
                                    </button>
                                    <button
                                        :disabled="count<1"
                                        class="btn btn-primary btn-sm mr-2"
                                        @click="exportMembers('csv')">
                                        <i class="fa fa-download"></i> CSV
                                    </button>
                                    <button
                                        :disabled="count<1"
                                        class="btn btn-primary btn-sm"
                                        @click="exportMembers('xlsx')">
                                        <i class="fa fa-download"></i> Excel
                                    </button>
                                </div>
                            </b-row>
                            <v-server-table
                                :columns="columns"
                                :options="options"
                                :theme="theme"
                                id="dataTable"
                                ref="dataTable"
                                md="12"
                                lg="12"
                                sm="12"
                                @sorted="tableSorted">
                                <template slot="beforeBody">
                                    <tr v-if="loading">
                                        <td class="text-center loading" :colspan="15"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                                    </tr>
                                </template>
                                <template slot="uuid" slot-scope="props">
                                    <router-link :to="{ path: '/partners/accounts/edit/'+props.row.uuid }">
                                        <i class="fa fa-pencil"></i>
                                    </router-link>
                                </template>
                                <template slot="headquarters" slot-scope="props">
                                    <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                                    <template>{{ props.row.headquarters.name }}</template>
                                </template>
                                <template slot="emails" slot-scope="props">
                                    <ul style="list-style-type:none;">
                                        <li v-for="email in props.row.emails">{{ email.email }}</li>
                                    </ul>
                                </template>
                                <template slot="paymentMethod" slot-scope="props">
                                    <payment-method-name :value="props.row.paymentMethod"></payment-method-name>
                                </template>
                                <template slot="receiptIssueDate" slot-scope="props">
                                    <issue-date-name :value="props.row.receiptIssueDate"></issue-date-name>
                                </template>
                                <template slot="registeredAt" slot-scope="props">
                                  {{ new Date(props.row.registeredAt) | dateFormat('DD/MM/YYYY') }}
                                </template>
                                <template slot="deactivatedAt" slot-scope="props" v-if="props.row.deactivatedAt">
                                  {{ new Date(props.row.deactivatedAt) | dateFormat('DD/MM/YYYY') }}
                                </template>
                                <template slot="businessManager" slot-scope="props" v-if="props.row.businessManager">
                                  <template>{{ props.row.businessManager.firstname }} {{ props.row.businessManager.lastname }}</template>
                                </template>
                                <template slot="unsubscribeReasonValue" slot-scope="props" v-if="props.row.unsubscribeReasonId">
                                  <template>{{ props.row.unsubscribeReasonId.name }}</template>
                                </template>
                                <template slot="agreements" slot-scope="props">
                                  <ul style="list-style-type:none;">
                                    <li v-for="agr in props.row.agreements">{{ agr.name }}</li>
                                  </ul>
                                </template>
                            </v-server-table>
                        </b-card>
                    </b-col>
                </b-row>

            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {request} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import form from '@/helpers/form';
    import {filterActiveUsers} from '@/helpers/user-helper';
    import {ServerTable, Event} from 'vue-tables-2';
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import {memberStatusOptions, memberLocatedOptions} from '@/constants/client-constants';
    import ReceiptIssueDateMultipleSelector from '@/components/clients/members/ReceiptIssueDateMultipleSelector';
    import feeAgreementSelector from '@/components/agreements/FeeAgreementSelector';
    import FeeTypeMultipleSelector from '@/components/fee-types/FeeTypeMultipleSelector';
    import PaymentMethodMultipleSelector from '@/components/clients/members/PaymentMethodMultipleSelector';
    import paymentMethodName from '@/components/clients/members/PaymentMethodName';
    import issueDateName from '@/components/issue-date/IssueDateName';

    import Spinner from 'vue-simple-spinner';
    import CnaeSelector from '@/components/clients/cnaes/CnaeSelector';
    import headquartersMultipleSelector from '@/components/headquarters/HeadquartersMultipleSelector';
    import {issueDatesMonths} from '@/constants/issue-date-constants';
    import {paymentMethodsObject} from '@/constants/payment-constants';

    Vue.use(ServerTable);

    setupCalendar({
        firstDayOfWeek: 2, // Monday
    });

    export default {
        name: 'search-partners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            paymentMethodName,
            issueDateName,
            ReceiptIssueDateMultipleSelector,
            headquartersMultipleSelector,
            feeAgreementSelector,
            FeeTypeMultipleSelector,
            Spinner,
            PaymentMethodMultipleSelector,
            CnaeSelector
        },
        mounted() {
            // vue-tables events
            Event.$on('vue-tables.loading', (data) => {
                this.$_loadingMixin_showLoading();
                this.count = 0;
                this.loading = true;
                if (!!this.$refs.dataTable && !!this.$refs.dataTable.data) {
                    this.$refs.dataTable.data = [];
                }
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'none';
                }
            });
            Event.$on('vue-tables.loaded', (data) => {
                if (!!data && !!data.data && !!data.data.count) {
                    this.count = data.data.count;
                }
                this.$_loadingMixin_hideLoading();
                this.loading = false;
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'table-row';
                }
            });
            Event.$on('vue-tables.pagination', (page) => {
                this.request.page = page;
            });

            //this.entity = this.partner
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.requests('users', 'get', 200, 'users');
            this.requests('unsubscribe/reasons', 'get', 200, 'unsubscribeReasons');
            this.options.texts = form.tableLabels();

        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Agregar Socio',
                        path: '/partners/accounts/add',
                        brand: 'fa fa-user'
                    },
                ],
                title: 'Búsqueda avanzada de socios',
                entity: {
                    active: null,
                    located: null,
                    headquarters: [],
                    code: null,
                    name: null,
                    surname: null,
                    nif: null,
                    email: null,
                    emailStatus: null,
                    phone: null,
                    companyCif: null,
                    companyName: null,
                    businessManagerId: null,
                    iban: null,
                    province: null,
                    town: null,
                    postalCode: null,
                    agreement: null,
                    feeTypes: [],
                    receiptIssueDates: [],
                    shareDataToThirdParties: null,
                    includeUnlinkedMembers: null,
                    unsubscribeReasonId: null,
                    unpaidAmount: null,
                    unpaidReceipts: null,
                    queriesMinimum: null,
                    paymentMethods: [],
                    registeredAt: null,
                    sex: null,
                    isExemption: false,
                    age: null,
                },
                sex: [
                    {uuid: 1, name: 'Hombre'},
                    {uuid: 2, name: 'Mujer'},
                    {uuid: 3, name: 'Otra identidad'},
                ],
                cnae: null,
                orderBy: {
                    column: null,
                    ascending: null
                },
                request: {
                    page: 1,
                    itemsPerPage: 10
                },
                partners: [],
                count: 0,
                show: false,
                reasons: [],
                users: [],
                unsubscribeReason: false,
                showUnpaidAmount: false,
                showUnpaidReceipts: false,
                registerDateBegin: null,
                registerDateEnd: null,
                deActiveDateBegin: null,
                deActiveDateEnd: null,
                showQueriesMinimum: false,
                commercials: [],
                communities: [],
                provinces: [],
                towns: [],
                postalCodes: [],
                unsubscribeReasons: [],
                loading: true,
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        code: 'Código',
                        surname: 'Apellidos',
                        nif: 'NIF',
                        emails: 'Emails',
                        headquarters: 'Sede',
                        receiptIssueDate: 'Fecha de emisión',
                        'feeType.name': 'Tipo de cuota',
                        paymentMethod: 'Forma de pago',
                        registeredAt: 'Fecha de Alta',
                        deactivatedAt: 'Fecha de Baja',
                        businessManager: 'Gestor Comercial',
                        unsubscribeReasonValue: 'Motivo de Baja',
                        agreements: 'Convenio'

                    },
                    requestFunction: data => {
                        this.request.itemsPerPage = data.limit;
                        return axios({
                            url: 'members/search',
                            method: 'post',
                            params: this.request,
                            data: this.searchParams,

                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    },
                    responseAdapter({data}) {
                        return {
                            data: data.members,
                            count: data.count
                        }
                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['uuid', 'code', 'name', 'surname', 'nif', 'emails', 'headquarters', 'receiptIssueDate', 'feeType', 'paymentMethod', 'registeredAt', 'deactivatedAt', 'businessManager', 'unsubscribeReasonValue', 'agreements'],
                    filterByColumn: false,
                    filterable: false,
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                columns: [
                    'uuid',
                    'code',
                    'name',
                    'surname',
                    'nif',
                    'emails',
                    'headquarters',
                    'receiptIssueDate',
                    'feeType.name',
                    'paymentMethod',
                    'registeredAt',
                    'deactivatedAt',
                    'businessManager',
                    'unsubscribeReasonValue',
                    'agreements'
                ],
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                strings: ['companyWorkersNumber'],
                arrays: ['addresses']
            }
        },
        computed: {
            memberStatusOptions() {
                return memberStatusOptions;
            },
            memberLocatedOptions() {
                return memberLocatedOptions;
            },
            searchParams() {
                // if(this.deActiveDateBegin !== null || this.deActiveDateEnd !== null) {
                //   this.columns.filter(i => i == "deactivatedAt").length > 0 ? null : this.columns.push('deactivatedAt');
                //   this.options.headings.hasOwnProperty("key") ? null : this.options.headings["deactivatedAt"] = "Fecha de Baja";
                //   this.options.sortable.filter(i => i == "deactivatedAt").length > 0 ? null : this.options.sortable.push("deactivatedAt");
                // } else {
                //   this.columns.pop();
                //   delete this.options.headings["deactivatedAt"];
                //   this.options.sortable.pop();
                // }
                return {
                    active: (!!this.entity.active ? this.entity.active.key : null),
                    located: (!!this.entity.located ? this.entity.located.key : null),
                    headquarters: (!!this.entity.headquarters ? this.entity.headquarters.map((h) => h.uuid) : null),
                    code: this.entity.code,
                    name: this.entity.name,
                    surname: this.entity.surname,
                    nif: this.entity.nif,
                    email: this.entity.email,
                    emailStatus: this.entity.emailStatus,
                    phone: this.entity.phone,
                    companyCif: this.entity.companyCif,
                    companyName: this.entity.companyName,
                    businessManagerId: this.entity.businessManagerId,
                    iban: this.entity.iban,
                    province: this.entity.province,
                    town: this.entity.town,
                    postalCode: this.entity.postalCode,
                    agreementId: (!!this.entity.agreement ? this.entity.agreement.uuid : null),
                    feeTypes: this.entity.feeTypes,
                    receiptIssueDates: this.entity.receiptIssueDates,
                    shareDataToThirdParties: this.entity.shareDataToThirdParties,
                    includeUnlinkedMembers: this.entity.includeUnlinkedMembers,
                    unsubscribeReasonId: this.entity.unsubscribeReasonId,
                    unpaidAmount: this.entity.unpaidAmount,
                    unpaidReceipts: this.entity.unpaidReceipts,
                    queriesMinimum: this.entity.queriesMinimum,
                    orderColumn: this.orderBy.column,
                    orderAscending: this.orderBy.ascending,
                    sex: this.entity.sex,
                    paymentMethods: this.entity.paymentMethods,
                    registeredAt: this.entity.registeredAt,
                    exemptFromPayment: this.entity.isExemption,
                    cnae: (!!this.cnae ? this.cnae.uuid : null),
                    age: this.entity.age,
                    registerDateBegin: this.registerDateBegin,
                    registerDateEnd: this.registerDateEnd,
                    deActiveDateBegin: this.deActiveDateBegin,
                    deActiveDateEnd: this.deActiveDateEnd
                };
            }
        },
        methods: {
            filterUsers: filterActiveUsers,
            getUserLabel(userUuid) {
                let user = this.getUserByUuid(userUuid);
                if (!!user && !!user.firstname && !!user.lastname) {
                    return `${user.firstname} ${user.lastname}`;
                } else {
                    return '';
                }
            },
            getUserDepartmentLabel(userUuid) {
                let user = this.getUserByUuid(userUuid);
                if (!!user.department && !!user.department.description) {
                    return user.department.description;
                } else {
                    return '';
                }
            },
            getUserByUuid(userUuid) {
                return this.users.find(user => user.uuid === userUuid);
            },
            customLabel({firstname, lastname}) {
                return `${firstname} – ${lastname}`;
            },
            async requests(path, method, okCode, entity) {
                this.$_loadingMixin_showLoading();
                this[entity] = await request(path, method, okCode);
                this.$_loadingMixin_hideLoading();
            },
            search() {
                this.show = true;
                if (!!this.$refs.dataTable) {
                    this.$refs.dataTable.refresh();
                }
            },
            validate() {
                //if(this.strings.filter(string => !this.entity[string] ).length > 0){ return false }
                //if(this.arrays.filter(array => this.entity[array].length == 0).length > 0){ return false }
                //if(this.errors.items.length > 0){ return false }
                return true

            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref);
                } else {
                    return null;
                }
            },
            normalizeMember(member, type = 'legacy') {
                if (type === 'legacy') {
                    let emails = null;
                    if (member.emails !== undefined) {
                        emails = member.emails.reduce(
                            (accumulator, currentMember) => accumulator + currentMember.email + ' ',
                            ''
                        )
                    }
                    let headquarters = null;
                    if (member.headquarters !== undefined) {
                        headquarters = member.headquarters.name
                    }
                    let registerDateValue = null;
                    if (member.registeredAt !== undefined) {
                      registerDateValue = member.registeredAt
                    }
                    let deActiveDateValue = null;
                    if (member.deactivatedAt !== undefined) {
                      deActiveDateValue = member.deactivatedAt
                    }
                    let businessManager = null;
                    if (member.businessManager !== undefined) {
                        businessManager = member.businessManager.firstname + ' ' + member.businessManager.lastname
                    }
                    let unsubscribeReasonValue = null;
                    if (member.unsubscribeReasonId !== undefined) {
                        unsubscribeReasonValue = member.unsubscribeReasonId.name
                    }
                    let agreements = null;
                    if (member.agreements !== undefined) {
                      agreements = member.agreements.reduce(
                        (accumulator, currentMember) => accumulator + currentMember.name + ' ',
                        ''
                      )
                    }
                    const issueDateValue = issueDatesMonths[member.receiptIssueDate]
                    let feeTypeValue = null;
                    if (member.feeType !== undefined) {
                      feeTypeValue = member.feeType.name;
                    }

                    return {
                        'Código': member.code,
                        'Nombre': member.name,
                        'Apellidos': member.surname,
                        'NIF': member.nif,
                        'Emails': emails,
                        'Sede': headquarters,
                        'Fecha de emisión': issueDateValue,
                        'Tipo de cuota': feeTypeValue,
                        'Forma de pago': paymentMethodsObject[member.paymentMethod],
                        'Fecha de Alta': registerDateValue,
                        'Fecha de Baja': deActiveDateValue,
                        'Gestor Comercial' : businessManager,
                        'Motivo de Baja': unsubscribeReasonValue,
                        'Convenio': agreements
                    }
                } else {
                    let emails = null;
                    let phones = null;
                    let province = null;
                    let town = null;
                    let postalCode = null;
                    let address = null;
                    let agreements = null;
                    if (member.emails !== undefined) {
                        emails = member.emails.reduce(
                            (accumulator, currentMember) => accumulator + currentMember.email + ',',
                            ''
                        )
                    }
                    if (member.phones !== undefined) {
                         phones = member.phones.reduce(
                            (accumulator, currentMember) => accumulator + currentMember.phone + ',',
                            ''
                        )
                    }
                    if (member.addresses !== undefined) {
                         province = member.addresses.reduce((accumulator, currentMember) => accumulator + currentMember.province + ',', '')
                         town = member.addresses.reduce((accumulator, currentMember) => accumulator + currentMember.town + ',', '')
                         postalCode = member.addresses.reduce((accumulator, currentMember) => accumulator + currentMember.postalCode + ',', '')
                         address = member.addresses.reduce((accumulator, currentMember) => accumulator + currentMember.address + ',', '')
                    }
                    if (member.agreements !== undefined) {
                      agreements = member.agreements.reduce(
                        (accumulator, currentMember) => accumulator + currentMember.name + ' ',
                        ''
                      )
                    }
                    let headquarters = null;
                    if (member.headquarters !== undefined) {
                        headquarters = member.headquarters.name
                    }
                    let registerDateValue = null;
                    if (member.registeredAt !== undefined) {
                      registerDateValue = member.registeredAt
                    }
                    let deActiveDateValue = null;
                    if (member.deactivatedAt !== undefined) {
                      deActiveDateValue = member.deactivatedAt
                    }
                    let businessManager = null;
                    if (member.businessManager !== undefined) {
                      businessManager = member.businessManager.firstname + ' ' + member.businessManager.lastname
                    }
                    let unsubscribeReasonValue = null;
                    if (member.unsubscribeReasonId !== undefined) {
                      unsubscribeReasonValue = member.unsubscribeReasonId.name
                    }
                    const issueDateValue = issueDatesMonths[member.receiptIssueDate]
                    let feeTypeValue = null;
                    if (member.feeType !== undefined) {
                      feeTypeValue = member.feeType.name;
                    }

                    return {
                        'Id': member.uuid,
                        'Código': member.code,
                        'Nombre': member.name,
                        'Apellidos': member.surname,
                        'NIF': member.nif,
                        'Emails': emails,
                        'Sede': headquarters,
                        'Sexo': member.sex,
                        'Cumpleaños': member.birthday,
                        'Telefonos': phones,
                        'Provincia': province,
                        'Población': town,
                        'Código Postal': postalCode,
                        'Dirección': address,
                        'Activo': member.active,
                        'Localizado': member.located,
                        'Fecha de emisión': issueDateValue,
                        'Tipo de cuota': feeTypeValue,
                        'Forma de pago': paymentMethodsObject[member.paymentMethod],
                        'Fecha de Alta': registerDateValue,
                        'Fecha de Baja': deActiveDateValue,
                        'Gestor Comercial' : businessManager,
                        'Motivo de Baja': unsubscribeReasonValue,
                        'Convenio': agreements
                    }
                }
            },
            async exportMembers(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    let response = await axios({
                        method: 'post',
                        url: 'members/search',
                        params: {
                            page: 1,
                            itemsPerPage: this.count
                        },
                        data: this.searchParams
                    });

                    let self = this;
                    let rows;
                    if (format === '') {
                        rows = response.data.members.map(function (member) {
                            return self.normalizeMember(member, 'all');
                        });
                    } else {
                        rows = response.data.members.map(function (member) {
                            return self.normalizeMember(member);
                        });
                    }


                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else {
                        downloadJsonAsXlsx(rows)
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            tableSorted(data) {
                this.orderBy.column = data.column;
                this.orderBy.ascending = data.ascending;
            }
        },
        watch: {
            showUnpaidAmount: function () {
                if (this.showUnpaidAmount === false) {
                    this.entity.unpaidAmount = null;
                }
            },
            showUnpaidReceipts: function () {
                if (this.showUnpaidReceipts === false) {
                    this.entity.unpaidReceipts = null;
                }
            },
            showQueriesMinimum: function () {
                if (this.showQueriesMinimum === false) {
                    this.entity.queriesMinimum = null;
                }
            }
        }
    }
</script>
<style lang="scss">
    #dataTable {
        width: 100%;
        margin: 0 auto;

        .VuePagination {
            text-align: center;
            justify-content: center;
        }

        .vue-title {
            text-align: center;
            margin-bottom: 10px;
        }

        .VueTables__search-field {
            display: flex;
        }

        .VueTables__search-field input {
            margin-left: 0.25rem;
        }

        .VueTables__limit-field {
            display: flex;
        }

        .VueTables__limit-field select {
            margin-left: 0.25rem !important;
        }

        .VueTables__table th {
            text-align: center;
        }

        .VueTables__child-row-toggler {
            width: 16px;
            height: 16px;
            line-height: 16px;
            display: block;
            margin: auto;
            text-align: center;
        }

        .VueTables__child-row-toggler--closed::before {
            content: "+";
        }

        .VueTables__child-row-toggler--open::before {
            content: "-";
        }
    }

    .fit {
        width: 25px;
        white-space: nowrap;
    }

    .VueTables__no-results {
        display: none;
    }
</style>
